<template>
  <div class="d-flex flex-column justify-content-center h-100">
    <b-card class="strong-shadow" no-body>
      <h1 class="title">
        {{ $t('auto_atendimento.home.bemvindo') }} {{ $t('auto_atendimento.autoatendimento') }}
      </h1>
      <div class="m-auto mt-5">
        <img src="@/assets/img/auto_atendimento/veusinho.png" width="200" alt="">
      </div>
      <div class="m-5">
        <router-link :to="{name: 'vaa.cadastro'}" class="btn btn-outline-warning btn-block">
          {{ $t('auto_atendimento.home.cadastrar') }}
        </router-link>
        <router-link :to="{name: 'vaa.orcamentos'}" class="btn btn-outline-warning btn-block">
          {{ $t('auto_atendimento.home.orcamento') }}
        </router-link>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Index"
}
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
  margin: 1rem auto 2rem;
  max-width: 75%;
  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
}
</style>
